import { isObject, size } from 'lodash-es';

import { resetFormExcept } from '../../../components/forms/formHelpers';

export function mergeLoadedTemplateIntoDrawerData(data, loadedTemplate) {
  return {
    ...data,
    adding: isObject(data?.adding)
      ? { ...data.adding, values: loadedTemplate }
      : data?.adding,
    editing: data?.editing && {
      ...data.editing,
      values: loadedTemplate,
    },
  };
}

export function copyShipmentTemplateIntoForm(forms, values) {
  if (size(forms) === 1) {
    forms[0].form.resetFields();
    forms[0].form.setFieldsValue({
      ...values,
      packages: values.packageList?.packages,
    });
  } else {
    forms[0].form.setFieldsValue(values.origin);
    forms[1].form.setFieldsValue(values.destination);
    forms[2].form.setFieldsValue(values.serviceInformation);

    forms[3].form.resetFields();
    forms[3].form.setFieldsValue(values.packageList);
  }
}

export function cancelShipmentTemplate(forms) {
  if (size(forms) === 4) {
    resetFormExcept(forms[0].form, [
      'pickupDateTime',
      'pickupDateTime-date',
      'pickupDateTime-time',
      'pickupDateTime-specialValue',
      'pickupDateTime-specialValueData',
    ]);
    resetFormExcept(forms[1].form, [
      'deliveryDateTime',
      'deliveryDateTime-date',
      'deliveryDateTime-time',
      'deliveryDateTime-specialValue',
      'deliveryDateTime-specialValueData',
    ]);
    resetFormExcept(forms[2].form, ['bolNumber', 'shipperSpecificInfo']);
    forms[3].form.resetFields();
  } else {
    resetFormExcept(forms[0].form, [
      // ready date
      'origin.pickupDateTime',
      'origin.pickupDateTime-date',
      'origin.pickupDateTime-time',
      'origin.pickupDateTime-specialValue',
      'origin.pickupDateTime-specialValueData',
      // deadline date
      'destination.deliveryDateTime',
      'destination.deliveryDateTime-date',
      'destination.deliveryDateTime-time',
      'destination.deliveryDateTime-specialValue',
      'destination.deliveryDateTime-specialValueData',
      'destination.deliveryDateTime-specialValue',
      'destination.deliveryDateTime-specialValueData',
      // service information fields
      'serviceInformation.bolNumber',
      'serviceInformation.shipperSpecificInfo',
    ]);
  }
}
